/* OPS-41 "Start Here" — the first-timer page
   Vanilla JS, no dependencies. Adapted from assets/lash-refills.js.

   THE QUESTION STEPPER ("1a"). One question at a time, collapsed behind
   one button until she starts. Tapping an answer advances automatically,
   so single-choice steps have no buttons to hunt for. Only the multi-pick
   "your life" step keeps a continue button.

   EDITING ANSWERS. "Change my answers" reopens at question one and then
   behaves EXACTLY like a first run: each answer advances to the next
   question. An earlier version jumped straight back to the box the moment
   anything changed, which made questions two and three unreachable, since
   single-choice steps have no next button. Do not reinstate that
   shortcut. The way back is the explicit "Back to my box" link.

   CHOOSING A VARIANT ON THE GRID (20 July 2026). Add to bag used to add a
   default silently. Now: one variant adds directly, one option gets chips
   on the card, and more than one option sends her to the product page
   (decided in the Liquid). The chips are CURATED by the block's chip
   options, which is how the Newbie Bundle's "No Lashes" variant stays out
   of reach on a page that promises complete boxes.

   MRI SAFETY. A scan-day customer must NEVER be shown a magnetic product,
   as pick OR option: magnetic lashes and liner are ferromagnetic MRI
   hazards. blockedForScanDays() is driven by each kit's "Contains
   magnets" setting rather than a hardcoded key, and resolve() overrides a
   magnetic pick if routing data ever puts one on a scan-day row. */

(function () {
  'use strict';
  if (window.__shStartHereInit) return;
  window.__shStartHereInit = true;

  var $ = function (sel, root) { return (root || document).querySelector(sel); };
  var $$ = function (sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); };

  function onReady(fn) {
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', fn);
    else fn();
  }

  function tidy(s) {
    if (!s) return '';
    return String(s).replace(/\s*—\s*/g, ', ').replace(/\s*–\s*/g, ', ');
  }

  onReady(function () {
    var guide = $('[data-sh-guide]');
    if (!guide) return;

    var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var scrollBehavior = reduceMotion ? 'auto' : 'smooth';

    function readJSON(id, fallback) {
      var el = document.getElementById(id);
      if (!el) return fallback;
      try { return JSON.parse(el.textContent); } catch (e) { return fallback; }
    }

    var strings = readJSON('sh-strings', {});
    var rules = readJSON('sh-routing', []);
    if (!Array.isArray(rules)) rules = [];

    /* ---------- kit catalogue ---------- */

    var kits = {};
    $$('[data-sh-kit-data]').forEach(function (dataEl) {
      var k;
      try { k = JSON.parse(dataEl.textContent); } catch (e) { return; }
      if (!k || !k.key) return;
      k.name = tidy(k.name);
      k.chipOptions = parseChips(k.chipOptions);
      if (!Array.isArray(k.images)) k.images = [];
      kits[k.key] = k;
    });

    function parseChips(raw) {
      if (!raw) return [];
      return String(raw).split(',').map(function (pair) {
        var bits = pair.split('|');
        var label = (bits[0] || '').trim();
        var match = (bits[1] || bits[0] || '').trim();
        return label ? { label: label, match: match } : null;
      }).filter(Boolean);
    }

    /* ---------- swipe galleries ---------- */

    function addGalleryDots(gal) {
      var track = $('[data-sh-gal-track]', gal);
      if (!track || $('.sh-gal__dots', gal)) return;
      var slides = $$('.sh-gal__slide', track);

      var dots = document.createElement('div');
      dots.className = 'sh-gal__dots';
      if (slides.length < 2) dots.hidden = true;

      slides.forEach(function (_, i) {
        var dot = document.createElement('button');
        dot.type = 'button';
        dot.className = 'sh-gal__dot';
        dot.setAttribute('aria-label', 'Photo ' + (i + 1));
        dot.setAttribute('aria-current', i === 0 ? 'true' : 'false');
        dot.addEventListener('click', function () {
          track.scrollTo({ left: track.clientWidth * i, behavior: scrollBehavior });
        });
        dots.appendChild(dot);
      });
      gal.appendChild(dots);

      var settle = null;
      track.addEventListener('scroll', function () {
        clearTimeout(settle);
        settle = setTimeout(function () {
          var i = Math.round(track.scrollLeft / Math.max(track.clientWidth, 1));
          $$('.sh-gal__dot', dots).forEach(function (d, n) {
            d.setAttribute('aria-current', n === i ? 'true' : 'false');
          });
        }, 60);
      }, { passive: true });
    }

    function buildGallery(kit, hero) {
      var images = (kit.images && kit.images.length) ? kit.images : [];
      if (!images.length) return null;

      var gal = document.createElement('div');
      gal.className = 'sh-gal' + (hero ? ' sh-gal--hero' : '');
      gal.setAttribute('data-sh-gal', '');

      var track = document.createElement('div');
      track.className = 'sh-gal__track';
      track.setAttribute('data-sh-gal-track', '');

      images.forEach(function (src, i) {
        var slide = document.createElement('div');
        slide.className = 'sh-gal__slide';
        var img = document.createElement('img');
        img.src = src;
        img.alt = i === 0 ? (kit.name || '') : '';
        img.loading = i === 0 ? 'eager' : 'lazy';
        img.width = 700; img.height = 700;
        img.draggable = false;
        slide.appendChild(img);
        track.appendChild(slide);
      });

      gal.appendChild(track);
      addGalleryDots(gal);
      return gal;
    }

    /* ---------- state ---------- */

    var state = { look: null, life: [], hands: null };
    var hasCompleted = false;

    /* ---------- cart ---------- */

    function cartAdd(variantId) {
      return fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id: parseInt(variantId, 10), quantity: 1 }] })
      }).then(function (r) { if (!r.ok) throw new Error('add'); return r.json(); });
    }
    function cartGet() {
      return fetch('/cart.js', { headers: { Accept: 'application/json' } })
        .then(function (r) { if (!r.ok) throw new Error('cart'); return r.json(); });
    }

    var errorEl = $('[data-sh-error]');
    var errorTimer = null;
    function showError() {
      if (!errorEl) return;
      errorEl.textContent = strings.addError || 'That did not add. Please try again.';
      errorEl.hidden = false;
      clearTimeout(errorTimer);
      errorTimer = setTimeout(function () { errorEl.hidden = true; }, 4000);
    }

    /* ---------- the tray ---------- */

    var trayBox = $('[data-sh-tray-box]');
    var trayStatus = $('[data-sh-tray-status]');

    var LOOK_ICON = { bare: '✧', soft: '✦', glam: '✹' };
    var LIFE_ICON = { glasses: '◎', mri: '⊕', nolash: '○', petite: '◦' };

    function renderTray() {
      if (!trayBox) return;
      var items = [];
      if (state.look) items.push({ cls: '', glyph: LOOK_ICON[state.look] || '✦', label: 'Your lashes' });
      state.life.forEach(function (chip) {
        if (chip === 'none' || !LIFE_ICON[chip]) return;
        items.push({ cls: ' sh-tray__item--charm', glyph: LIFE_ICON[chip], label: chip });
      });
      if (state.hands) {
        items.push({ cls: '', glyph: '✎', label: 'Your liner' });
        items.push({ cls: '', glyph: '⚒', label: 'Applicator tool' });
      }

      trayBox.innerHTML = items.map(function (it) {
        return '<span class="sh-tray__item' + it.cls + '" title="' + it.label + '">' + it.glyph + '</span>';
      }).join('');

      var answered = 0;
      if (state.look) answered++;
      if (state.life.length) answered++;
      if (state.hands) answered++;

      if (trayStatus) {
        var line = strings.trayEmpty;
        if (answered === 1) line = strings.trayOne;
        else if (answered === 2) line = strings.trayTwo;
        else if (answered >= 3) line = strings.trayThree;
        trayStatus.textContent = line || '';
      }
    }

    /* ---------- routing ---------- */

    function ruleMatches(rule) {
      if (rule.look && rule.look !== state.look) return false;
      if (rule.hands && rule.hands !== state.hands) return false;
      if (rule.life) {
        var needed = String(rule.life).split(',').map(function (s) { return s.trim(); }).filter(Boolean);
        for (var i = 0; i < needed.length; i++) {
          if (state.life.indexOf(needed[i]) === -1) return false;
        }
      }
      return true;
    }

    function pickRule() {
      var best = null;
      var bestP = Infinity;
      rules.forEach(function (rule) {
        if (!ruleMatches(rule)) return;
        var p = typeof rule.p === 'number' ? rule.p : 99;
        if (p < bestP) { best = rule; bestP = p; }
      });
      return best;
    }

    function onScanDays() { return state.life.indexOf('mri') !== -1; }
    function blockedForScanDays(key) {
      var kit = kits[key];
      return !!(kit && kit.hasMagnets) && onScanDays();
    }

    function resolveVariant(kit, rule, chipLabel) {
      if (!kit || !kit.variants || !kit.variants.length) return null;

      var chipMatches = (kit.chipOptions || []).map(function (o) { return o.match.toLowerCase(); });
      var parts = (rule && Array.isArray(rule.variant) ? rule.variant : []).filter(function (p) {
        return chipMatches.indexOf(String(p).toLowerCase()) === -1;
      });

      var chipMatch = null;
      if (kit.chipOptions && kit.chipOptions.length) {
        var wanted = chipLabel || (rule && rule.chip) || kit.chipOptions[0].label;
        var opt = kit.chipOptions.filter(function (o) { return o.label === wanted; })[0] || kit.chipOptions[0];
        chipMatch = opt.match;
      }

      /* Fall back to the kit's pinned default ONLY when nothing else is
         narrowing the choice. If a chip is selected, the chip IS the
         choice: adding the default on top makes the two contradict and
         match no variant at all (picking "Rhonda" while the default
         pins "Emily", for instance). The default exists to stop the
         cheapest variant winning where that is a no-lashes or no-liner
         option, not to override a deliberate selection. */
      if (!parts.length && !chipMatch && kit.defaultVariantMatch) {
        parts = [kit.defaultVariantMatch];
      }

      function find(requireAvailable) {
        return kit.variants.filter(function (v) {
          if (requireAvailable && !v.available) return false;
          var title = String(v.title).toLowerCase();
          for (var i = 0; i < parts.length; i++) {
            if (title.indexOf(String(parts[i]).toLowerCase()) === -1) return false;
          }
          if (chipMatch && title.indexOf(chipMatch.toLowerCase()) === -1) return false;
          return true;
        })[0] || null;
      }

      return find(true) || find(false) || kit.variants.filter(function (v) { return v.available; })[0] || null;
    }

    function resolve() {
      var rule = pickRule();
      if (!rule) return null;

      var kit = kits[rule.kit];
      if (!kit) return null;
      var usedRuleVariant = true;

      if (blockedForScanDays(rule.kit)) {
        var safeKey = null;
        var candidates = [rule.alt].concat(Array.isArray(rule.also) ? rule.also : []);
        candidates.forEach(function (k) {
          if (!safeKey && k && kits[k] && !kits[k].hasMagnets) safeKey = k;
        });
        if (!safeKey) {
          Object.keys(kits).forEach(function (k) {
            if (!safeKey && !kits[k].hasMagnets) safeKey = k;
          });
        }
        if (safeKey) { kit = kits[safeKey]; usedRuleVariant = false; }
      }

      var variant = resolveVariant(kit, usedRuleVariant ? rule : null, null);
      var promoted = false;

      if ((!variant || !variant.available) && rule.alt && kits[rule.alt] && !blockedForScanDays(rule.alt)) {
        var altVariant = resolveVariant(kits[rule.alt], null, null);
        if (altVariant && altVariant.available) {
          kit = kits[rule.alt];
          variant = altVariant;
          promoted = true;
        }
      }

      return { rule: rule, kit: kit, variant: variant, promoted: promoted };
    }

    /* ---------- the reveal ---------- */

    var reveal = $('[data-sh-reveal]');
    var rMedia = $('[data-sh-reveal-media]');
    var rName = $('[data-sh-reveal-name]');
    var rStars = $('[data-sh-reveal-stars]');
    var rReason = $('[data-sh-reveal-reason]');
    var rContents = $('[data-sh-reveal-contents]');
    var rLiner = $('[data-sh-reveal-liner]');
    var rCare = $('[data-sh-reveal-care]');
    var rChipRow = $('[data-sh-reveal-chiprow]');
    var rChipLabel = $('[data-sh-reveal-chiplabel]');
    var rChips = $('[data-sh-reveal-chips]');
    var rPrice = $('[data-sh-reveal-price]');
    var rAdd = $('[data-sh-reveal-add]');
    var rSoldOut = $('[data-sh-reveal-soldout]');
    var rPdp = $('[data-sh-reveal-pdp]');
    var rDramatic = $('[data-sh-reveal-dramatic]');
    var rActions = $('.sh-reveal__actions');
    var choice = $('[data-sh-choice]');
    var altsWrap = $('[data-sh-alts]');
    var altsLabel = $('[data-sh-alts-label]');
    var altsGrid = $('[data-sh-alts-grid]');

    var chosenChip = null;

    function buildAltCard(kit, variant) {
      var card = document.createElement('div');
      card.className = 'sh-alt';

      var gal = buildGallery(kit, false);
      if (gal) {
        var media = document.createElement('div');
        media.className = 'sh-alt__media';
        media.appendChild(gal);
        if (kit.badge) {
          var tag = document.createElement('span');
          tag.className = 'sh-alt__tag';
          tag.textContent = kit.badge;
          media.appendChild(tag);
        }
        card.appendChild(media);
      }

      var body = document.createElement('div');
      body.className = 'sh-alt__body';

      var row = document.createElement('div');
      row.className = 'sh-alt__row';
      var name = document.createElement('span');
      name.className = 'sh-alt__name';
      name.textContent = kit.name || '';
      var price = document.createElement('span');
      price.className = 'sh-alt__price';
      price.textContent = variant && variant.priceFormatted ? variant.priceFormatted : '';
      row.appendChild(name); row.appendChild(price);
      body.appendChild(row);

      if (kit.character) {
        var why = document.createElement('p');
        why.className = 'sh-alt__why';
        why.textContent = tidy(kit.character);
        body.appendChild(why);
      }

      var actions = document.createElement('div');
      actions.className = 'sh-alt__actions';

      /* Same rule as the grid: only offer a one-tap add when there is
         nothing left to choose. Anything with more than one option goes
         to the product page rather than guessing a combination. */
      var needsChoosing = (kit.optionCount || 1) > 1 && kit.variants.length > 1;

      if (variant && variant.available && !needsChoosing) {
        var add = document.createElement('button');
        add.type = 'button';
        add.className = 'sh-alt__add';
        add.setAttribute('data-sh-alt-add', '');
        add.setAttribute('data-variant-id', variant.id);
        add.textContent = strings.altAdd || 'Add to bag';
        add.addEventListener('click', function () {
          if (add.classList.contains('is-added')) return;
          add.setAttribute('aria-disabled', 'true');
          cartAdd(variant.id).then(function () {
            add.textContent = strings.addedLabel || 'In your bag';
            add.classList.add('is-added');
            add.removeAttribute('aria-disabled');
          }).catch(function () {
            add.removeAttribute('aria-disabled');
            showError();
          });
        });
        actions.appendChild(add);
      } else if (variant && variant.available && needsChoosing) {
        var choose = document.createElement('a');
        choose.className = 'sh-alt__add';
        choose.style.textDecoration = 'none';
        choose.style.display = 'inline-flex';
        choose.style.alignItems = 'center';
        choose.style.justifyContent = 'center';
        choose.href = kit.url || '#';
        choose.textContent = strings.chooseLabel || 'Choose options';
        actions.appendChild(choose);
      } else {
        var out = document.createElement('span');
        out.className = 'sh-alt__soldout';
        out.textContent = 'Back soon';
        actions.appendChild(out);
      }

      var view = document.createElement('a');
      view.className = 'sh-alt__view';
      view.href = kit.url || '#';
      view.textContent = strings.altView || 'View';
      actions.appendChild(view);

      body.appendChild(actions);
      card.appendChild(body);
      return card;
    }

    function renderAlts(route) {
      if (!altsWrap || !altsGrid) return;
      altsGrid.innerHTML = '';
      if (altsLabel) altsLabel.textContent = strings.altsLabel || '';

      var keys = (route.rule && Array.isArray(route.rule.also)) ? route.rule.also : [];
      var shown = 0;
      keys.forEach(function (key) {
        if (shown >= 2) return;
        if (!key || key === route.kit.key) return;
        if (blockedForScanDays(key)) return;
        var kit = kits[key];
        if (!kit) return;
        altsGrid.appendChild(buildAltCard(kit, resolveVariant(kit, null, null)));
        shown++;
      });

      altsWrap.hidden = shown === 0;
      syncAltCartState();
    }

    function renderReveal(route, opts) {
      if (!reveal || !route || !route.kit) return;
      opts = opts || {};

      var kit = route.kit;
      var variant = route.variant;

      if (rMedia) {
        rMedia.innerHTML = '';
        var heroGal = buildGallery(kit, true);
        if (heroGal) { rMedia.appendChild(heroGal); rMedia.hidden = false; }
        else { rMedia.hidden = true; }
      }

      if (rName) rName.textContent = kit.name || '';

      if (rStars) {
        if (kit.raters) {
          rStars.className = 'sh-reveal__stars loox-rating';
          rStars.setAttribute('data-rating', kit.rating || '');
          rStars.setAttribute('data-raters', kit.raters || '');
        } else {
          rStars.textContent = '';
        }
      }

      if (rReason) rReason.textContent = tidy(route.rule.reason || '');

      if (rContents) {
        var contents = kit.contents ? String(kit.contents).split('·').map(function (s) { return s.trim(); }).filter(Boolean) : [];
        if (contents.length) {
          rContents.innerHTML = contents.map(function (c) {
            return '<li><span class="sh-reveal__tick" aria-hidden="true">✦</span><span>' + c + '</span></li>';
          }).join('');
          rContents.hidden = false;
        } else {
          rContents.hidden = true;
        }
      }

      if (rLiner) {
        if (kit.linerLine) {
          rLiner.textContent = ((strings.linerLead || '') + ' ' + tidy(kit.linerLine)).trim();
          rLiner.hidden = false;
        } else {
          rLiner.hidden = true;
        }
      }

      if (rCare) {
        var care = '';
        if (onScanDays()) care = strings.mriNote;
        else if (state.life.indexOf('nolash') !== -1) care = strings.bareLidNote;
        else if (state.life.indexOf('glasses') !== -1) care = strings.glassesNote;
        if (care) { rCare.textContent = care; rCare.hidden = false; }
        else { rCare.hidden = true; }
      }

      if (rChipRow && rChips) {
        if (kit.chipOptions && kit.chipOptions.length > 1) {
          rChipLabel.textContent = kit.chipLabel || '';
          var activeLabel = chosenChip || (route.rule && route.rule.chip) || kit.chipOptions[0].label;
          rChips.innerHTML = '';
          kit.chipOptions.forEach(function (opt) {
            var probe = resolveVariant(kit, route.rule, opt.label);
            var btn = document.createElement('button');
            btn.type = 'button';
            btn.className = 'sh-chip';
            btn.textContent = opt.label + (probe && probe.priceFormatted ? ' · ' + probe.priceFormatted : '');
            btn.setAttribute('aria-pressed', opt.label === activeLabel ? 'true' : 'false');
            if (!probe || !probe.available) btn.disabled = true;
            btn.addEventListener('click', function () {
              chosenChip = opt.label;
              renderReveal({
                rule: route.rule, kit: kit, promoted: route.promoted,
                variant: resolveVariant(kit, route.rule, opt.label)
              }, { keepFocus: true });
            });
            rChips.appendChild(btn);
          });
          rChipRow.hidden = false;
        } else {
          rChips.innerHTML = '';
          rChipRow.hidden = true;
        }
      }

      if (rPrice) rPrice.textContent = variant && variant.priceFormatted ? variant.priceFormatted : '';

      if (rAdd) {
        var available = !!(variant && variant.available);
        rAdd.textContent = (strings.addLabel || 'Add my box') + (variant && variant.priceFormatted ? ' · ' + variant.priceFormatted : '');
        rAdd.classList.remove('is-added');
        rAdd.setAttribute('aria-disabled', available ? 'false' : 'true');
        rAdd.dataset.variantId = variant ? variant.id : '';
      }

      if (rSoldOut) {
        if (route.promoted) { rSoldOut.textContent = strings.soldOut || ''; rSoldOut.hidden = false; }
        else { rSoldOut.hidden = true; }
      }

      if (rPdp) rPdp.href = kit.url || '#';

      if (rDramatic) {
        var href = rDramatic.getAttribute('href');
        rDramatic.hidden = !(state.look === 'glam' && href && href !== '' && href !== '#');
      }

      renderAlts(route);

      reveal.hidden = false;
      if (choice) choice.hidden = false;

      if (window.loox && typeof window.loox.reload === 'function') {
        try { window.loox.reload(); } catch (e) { /* Loox not ready */ }
      }

      if (!opts.keepFocus) {
        reveal.focus();
        reveal.scrollIntoView({ behavior: scrollBehavior, block: 'center' });
      }

      if (kit.url) {
        try { history.replaceState(null, '', '#reveal-' + kit.url.split('/').pop()); } catch (e) { /* ignore */ }
      }
    }

    if (rAdd) {
      rAdd.addEventListener('click', function () {
        if (rAdd.getAttribute('aria-disabled') === 'true') return;
        var id = rAdd.dataset.variantId;
        if (!id) return;
        rAdd.setAttribute('aria-disabled', 'true');
        cartAdd(id).then(function () {
          rAdd.textContent = strings.addedLabel || 'In your bag';
          rAdd.classList.add('is-added');
          rAdd.setAttribute('aria-disabled', 'false');
        }).catch(function () {
          rAdd.setAttribute('aria-disabled', 'false');
          showError();
        });
      });
    }

    /* ---------- the question stepper ---------- */

    var cardsWrap = $('.sh-cards');
    var cards = $$('[data-sh-card]');
    var stepIndex = 0;
    var stepNumEl, stepFillEl, stepBackEl, stepsPanel, toBoxEl;

    function buildStepper() {
      if (!cardsWrap || !cards.length) return;

      var start = document.createElement('div');
      start.className = 'sh-start';
      var startBtn = document.createElement('button');
      startBtn.type = 'button';
      startBtn.className = 'sh-start__btn';
      startBtn.textContent = strings.startLabel || 'Find my pair';
      var chev = document.createElement('span');
      chev.setAttribute('aria-hidden', 'true');
      chev.textContent = '↓';
      startBtn.appendChild(chev);
      startBtn.addEventListener('click', function () {
        showStep(0);
        if (stepsPanel) stepsPanel.scrollIntoView({ behavior: scrollBehavior, block: 'center' });
      });
      start.appendChild(startBtn);
      if (strings.startNote) {
        var note = document.createElement('p');
        note.className = 'sh-start__note';
        note.textContent = strings.startNote;
        start.appendChild(note);
      }
      cardsWrap.appendChild(start);

      var panel = document.createElement('div');
      panel.className = 'sh-steps';
      stepsPanel = panel;

      var head = document.createElement('div');
      head.className = 'sh-steps__head';

      var label = document.createElement('span');
      label.className = 'sh-steps__label';
      label.setAttribute('aria-live', 'polite');
      stepNumEl = document.createElement('b');
      stepNumEl.textContent = '1';
      label.appendChild(document.createTextNode((strings.stepWord || 'Question') + ' '));
      label.appendChild(stepNumEl);
      label.appendChild(document.createTextNode(' ' + (strings.stepOf || 'of') + ' ' + cards.length));

      var rule = document.createElement('div');
      rule.className = 'sh-steps__rule';
      stepFillEl = document.createElement('div');
      stepFillEl.className = 'sh-steps__fill';
      rule.appendChild(stepFillEl);

      stepBackEl = document.createElement('button');
      stepBackEl.type = 'button';
      stepBackEl.className = 'sh-steps__back';
      stepBackEl.textContent = strings.backLabel || 'Back';
      stepBackEl.hidden = true;
      stepBackEl.addEventListener('click', function () { showStep(Math.max(0, stepIndex - 1)); });

      head.appendChild(label);
      head.appendChild(rule);
      head.appendChild(stepBackEl);
      panel.appendChild(head);

      cards.forEach(function (c) { panel.appendChild(c); });
      cardsWrap.appendChild(panel);

      var foot = document.createElement('div');
      foot.className = 'sh-steps__browse';

      toBoxEl = document.createElement('button');
      toBoxEl.type = 'button';
      toBoxEl.className = 'sh-steps__back sh-steps__tobox';
      toBoxEl.textContent = strings.toBoxLabel || 'Back to my box';
      toBoxEl.style.marginRight = '1.6rem';
      toBoxEl.hidden = true;
      toBoxEl.addEventListener('click', function () {
        if (renderIfComplete()) finishSteps();
      });
      foot.appendChild(toBoxEl);

      var browse = $('.sh-hero__browse');
      if (browse) {
        foot.appendChild(browse);
        browse.addEventListener('click', function (e) {
          e.preventDefault();
          collapseSteps();
          var boxes = document.getElementById('sh-kits');
          if (boxes) boxes.scrollIntoView({ behavior: scrollBehavior, block: 'start' });
        });
      }

      cardsWrap.appendChild(foot);
    }

    function showStep(i) {
      stepIndex = i;
      cards.forEach(function (c, n) { c.classList.toggle('is-active', n === i); });
      if (cardsWrap) cardsWrap.classList.remove('is-done', 'is-collapsed');
      if (stepNumEl) stepNumEl.textContent = String(i + 1);
      if (stepFillEl) stepFillEl.style.width = Math.round(((i + 1) / cards.length) * 100) + '%';
      if (stepBackEl) stepBackEl.hidden = i === 0;
      if (toBoxEl) toBoxEl.hidden = !hasCompleted;
      var q = $('.sh-card__q', cards[i]);
      if (q) { q.setAttribute('tabindex', '-1'); q.focus({ preventScroll: true }); }
    }

    function collapseSteps() {
      if (!cardsWrap) return;
      cardsWrap.classList.remove('is-done');
      cardsWrap.classList.add('is-collapsed');
    }

    function finishSteps() {
      hasCompleted = true;
      if (cardsWrap) cardsWrap.classList.add('is-done');
    }

    function firePop(cardEl) {
      if (reduceMotion) return;
      var pop = $('[data-sh-pop]', cardEl);
      if (!pop) return;
      pop.classList.remove('is-firing');
      void pop.offsetWidth;
      pop.classList.add('is-firing');
    }

    function complete() {
      return state.look && state.life.length && state.hands;
    }

    function renderIfComplete() {
      if (!complete()) return false;
      chosenChip = null;
      var route = resolve();
      if (route) renderReveal(route);
      return true;
    }

    /* Always walk forward, first run or edit. Do NOT add a shortcut that
       jumps back to the box on any change: it makes later questions
       unreachable. */
    function advanceFrom(i) {
      if (i >= cards.length - 1) {
        if (renderIfComplete()) finishSteps();
        return;
      }
      showStep(i + 1);
    }

    function syncLifeChips() {
      $$('[data-sh-answer][data-group="life"]').forEach(function (b) {
        b.setAttribute('aria-pressed', state.life.indexOf(b.getAttribute('data-value')) !== -1 ? 'true' : 'false');
      });
    }

    $$('[data-sh-answer]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var group = btn.getAttribute('data-group');
        var value = btn.getAttribute('data-value');
        var cardEl = btn.closest('[data-sh-card]');
        var idx = cards.indexOf(cardEl);

        if (btn.getAttribute('data-multi') === 'true') {
          var on = btn.getAttribute('aria-pressed') === 'true';
          if (value === 'none') {
            state.life = on ? [] : ['none'];
          } else {
            state.life = state.life.filter(function (v) { return v !== 'none'; });
            if (on) state.life = state.life.filter(function (v) { return v !== value; });
            else state.life.push(value);
          }
          syncLifeChips();
          firePop(cardEl);
          renderTray();
          return;
        }

        state[group] = value;
        $$('[data-sh-answer][data-group="' + group + '"]').forEach(function (b) {
          b.setAttribute('aria-pressed', b === btn ? 'true' : 'false');
        });
        firePop(cardEl);
        renderTray();
        advanceFrom(idx);
      });
    });

    var lifeDone = $('[data-sh-done-life]');
    if (lifeDone) {
      lifeDone.addEventListener('click', function () {
        if (!state.life.length) state.life = ['none'];
        syncLifeChips();
        renderTray();
        advanceFrom(cards.indexOf(lifeDone.closest('[data-sh-card]')));
      });
    }

    /* ---------- Meet the boxes ---------- */

    /* Variant chips on a grid card. Only built where the Liquid decided
       there is exactly one option to answer; anything with more options
       became a "Choose options" link to the product page instead. */
    function buildGridOptions() {
      $$('[data-sh-kit-opts]').forEach(function (holder) {
        var card = holder.closest('.sh-kit');
        if (!card) return;
        var kit = kits[card.getAttribute('data-key')];
        if (!kit) return;

        var addBtn = $('[data-sh-kit-add]', card);
        var priceEl = $('[data-sh-kit-price]', card);
        if (!addBtn) return;
        var addLabel = addBtn.textContent.trim();

        var opts = (kit.chipOptions && kit.chipOptions.length)
          ? kit.chipOptions
          : kit.variants.map(function (v) { return { label: v.title, match: v.title }; });
        if (opts.length < 2) return;

        if (kit.chipLabel) {
          var lab = document.createElement('div');
          lab.className = 'sh-kit__optlabel';
          lab.textContent = kit.chipLabel;
          holder.appendChild(lab);
        }

        var row = document.createElement('div');
        row.className = 'sh-kit__optrow';

        function select(opt, btn) {
          $$('.sh-chip', row).forEach(function (c) { c.setAttribute('aria-pressed', 'false'); });
          btn.setAttribute('aria-pressed', 'true');
          var v = resolveVariant(kit, null, opt.label);
          if (!v) return;
          addBtn.setAttribute('data-variant-id', v.id);
          addBtn.classList.remove('is-added');
          addBtn.textContent = addLabel;
          addBtn.removeAttribute('aria-disabled');
          if (priceEl && v.priceFormatted) priceEl.textContent = v.priceFormatted;
        }

        var buttons = [];
        opts.forEach(function (opt) {
          var probe = resolveVariant(kit, null, opt.label);
          var btn = document.createElement('button');
          btn.type = 'button';
          btn.className = 'sh-chip';
          btn.textContent = opt.label;
          btn.setAttribute('aria-pressed', 'false');
          if (!probe || !probe.available) btn.disabled = true;
          btn.addEventListener('click', function () { select(opt, btn); });
          row.appendChild(btn);
          buttons.push({ opt: opt, btn: btn });
        });
        holder.appendChild(row);

        /* Start on the first option that can actually be bought, so the
           button, the price and the chips always agree. */
        var first = buttons.filter(function (b) { return !b.btn.disabled; })[0];
        if (first) select(first.opt, first.btn);
      });
    }

    /* The description AND the In the box panel hide entirely behind
       "See more" (28 July 2026, revised same day: a two-line teaser was
       not hidden enough for Marcha). The collapse is applied here, not
       in the Liquid, so a no-JS render shows the full text rather than
       content nobody can reach. */
    function buildDetailsToggles() {
      var kitsSection = $('[data-sh-kits]');
      if (!kitsSection) return;
      var moreLabel = kitsSection.getAttribute('data-more-label') || 'See more';
      var lessLabel = kitsSection.getAttribute('data-less-label') || 'See less';

      $$('[data-sh-kit-details]', kitsSection).forEach(function (details, i) {
        details.classList.add('is-collapsed');
        details.id = details.id || 'sh-kit-details-' + i;
        var btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'sh-kit__morelink';
        btn.textContent = moreLabel;
        btn.setAttribute('aria-expanded', 'false');
        btn.setAttribute('aria-controls', details.id);
        btn.addEventListener('click', function () {
          var collapsed = details.classList.toggle('is-collapsed');
          btn.textContent = collapsed ? moreLabel : lessLabel;
          btn.setAttribute('aria-expanded', collapsed ? 'false' : 'true');
        });
        details.insertAdjacentElement('afterend', btn);
      });
    }

    /* The product popup (28 July 2026). Tapping a box photo opens a
       large, not-full-screen quick view built from the catalogue JSON.
       An iframe of the real product page is NOT possible: Shopify
       serves every storefront page with X-Frame-Options: DENY and
       frame-ancestors 'none', so the quick view renders the same
       product data directly and links through to the full page.
       Gallery dots stay dots: their clicks never reach the media. */
    var modal = $('[data-sh-modal]');
    var modalBody = modal ? $('[data-sh-modal-body]', modal) : null;
    var modalPanel = modal ? $('[data-sh-modal-panel]', modal) : null;
    var modalCloseBtn = modal ? $('[data-sh-modal-close-btn]', modal) : null;
    var modalOpener = null;

    function buildQuickView(kit) {
      modalBody.innerHTML = '';

      var kitsSection = $('[data-sh-kits]');
      var inboxLabel = kitsSection ? (kitsSection.getAttribute('data-inbox-label') || 'In the box') : 'In the box';
      var viewLabel = kitsSection ? (kitsSection.getAttribute('data-view-label') || 'View full details') : 'View full details';

      var qv = document.createElement('div');
      qv.className = 'sh-qv';

      var media = document.createElement('div');
      media.className = 'sh-qv__media';
      var gal = buildGallery(kit, false);
      if (gal) media.appendChild(gal);
      qv.appendChild(media);

      var info = document.createElement('div');
      info.className = 'sh-qv__info';

      if (kit.badge) {
        var eyebrow = document.createElement('span');
        eyebrow.className = 'sh-qv__eyebrow';
        eyebrow.textContent = kit.badge;
        info.appendChild(eyebrow);
      }

      var name = document.createElement('h3');
      name.className = 'sh-qv__name';
      name.textContent = kit.name || '';
      info.appendChild(name);

      if (kit.raters) {
        var stars = document.createElement('div');
        stars.className = 'sh-qv__reviews loox-rating';
        stars.setAttribute('data-rating', kit.rating || '');
        stars.setAttribute('data-raters', kit.raters || '');
        info.appendChild(stars);
      }

      var price = document.createElement('div');
      price.className = 'sh-qv__price';
      info.appendChild(price);

      if (kit.character) {
        var desc = document.createElement('p');
        desc.className = 'sh-qv__desc';
        desc.textContent = tidy(kit.character);
        info.appendChild(desc);
      }

      if (kit.contents) {
        var inbox = document.createElement('div');
        inbox.className = 'sh-kit__inbox';
        var inboxLab = document.createElement('div');
        inboxLab.className = 'sh-kit__inbox-label';
        inboxLab.textContent = inboxLabel;
        var inboxItems = document.createElement('div');
        inboxItems.className = 'sh-kit__inbox-items';
        inboxItems.textContent = kit.contents;
        inbox.appendChild(inboxLab);
        inbox.appendChild(inboxItems);
        info.appendChild(inbox);
      }

      var actions = document.createElement('div');
      actions.className = 'sh-qv__actions';

      var current = resolveVariant(kit, null, null);
      var addBtn = null;

      function setPrice(v) {
        price.textContent = v && v.priceFormatted ? v.priceFormatted : '';
      }
      setPrice(current);

      /* Same proportionality rule as the grid: one option gets chips,
         more than one option goes to the product page. */
      var needsChoosing = (kit.optionCount || 1) > 1 && kit.variants.length > 1;

      if (kit.chipOptions && kit.chipOptions.length > 1 && !needsChoosing) {
        if (kit.chipLabel) {
          var chipLab = document.createElement('div');
          chipLab.className = 'sh-kit__optlabel';
          chipLab.textContent = kit.chipLabel;
          actions.appendChild(chipLab);
        }
        var row = document.createElement('div');
        row.className = 'sh-kit__optrow';
        row.style.marginBottom = '.4rem';
        kit.chipOptions.forEach(function (opt) {
          var probe = resolveVariant(kit, null, opt.label);
          var chip = document.createElement('button');
          chip.type = 'button';
          chip.className = 'sh-chip';
          chip.textContent = opt.label;
          chip.setAttribute('aria-pressed', 'false');
          if (!probe || !probe.available) chip.disabled = true;
          chip.addEventListener('click', function () {
            $$('.sh-chip', row).forEach(function (c) { c.setAttribute('aria-pressed', 'false'); });
            chip.setAttribute('aria-pressed', 'true');
            current = probe;
            setPrice(current);
            if (addBtn) {
              if (current && cartVariants[String(current.id)]) {
                addBtn.textContent = strings.addedLabel || 'In your bag';
                addBtn.classList.add('is-added');
              } else {
                addBtn.textContent = strings.altAdd || 'Add to bag';
                addBtn.classList.remove('is-added');
                addBtn.removeAttribute('aria-disabled');
              }
            }
          });
          row.appendChild(chip);
        });
        actions.appendChild(row);
      }

      if (kit.available === false) {
        var out = document.createElement('p');
        out.className = 'sh-qv__soldout';
        out.textContent = 'Back soon';
        actions.appendChild(out);
      } else if (needsChoosing) {
        var choose = document.createElement('a');
        choose.className = 'sh-btn';
        choose.href = kit.url || '#';
        choose.textContent = strings.chooseLabel || 'Choose options';
        actions.appendChild(choose);
      } else {
        addBtn = document.createElement('button');
        addBtn.type = 'button';
        addBtn.className = 'sh-btn';
        addBtn.textContent = strings.altAdd || 'Add to bag';
        addBtn.addEventListener('click', function () {
          if (!current || addBtn.classList.contains('is-added')) return;
          addBtn.setAttribute('aria-disabled', 'true');
          cartAdd(current.id).then(function () {
            addBtn.textContent = strings.addedLabel || 'In your bag';
            addBtn.classList.add('is-added');
            addBtn.removeAttribute('aria-disabled');
            cartVariants[String(current.id)] = true;
            $$('[data-sh-kit-add]').forEach(function (b) {
              if (String(b.getAttribute('data-variant-id')) === String(current.id)) {
                b.textContent = strings.addedLabel || 'In your bag';
                b.classList.add('is-added');
              }
            });
          }).catch(function () {
            addBtn.removeAttribute('aria-disabled');
            showError();
          });
        });
        if (current && cartVariants[String(current.id)]) {
          addBtn.textContent = strings.addedLabel || 'In your bag';
          addBtn.classList.add('is-added');
        }
        actions.appendChild(addBtn);
      }

      info.appendChild(actions);

      var pdp = document.createElement('a');
      pdp.className = 'sh-qv__pdp';
      pdp.href = kit.url || '#';
      pdp.textContent = viewLabel;
      info.appendChild(pdp);

      qv.appendChild(info);
      modalBody.appendChild(qv);
      modalBody.scrollTop = 0;

      /* Preselect the first buyable chip so button, price and chips
         agree, mirroring the grid cards. */
      var firstChip = $$('.sh-chip:not(:disabled)', actions)[0];
      if (firstChip) firstChip.click();

      if (window.loox && typeof window.loox.reload === 'function') {
        try { window.loox.reload(); } catch (e) { /* Loox not ready */ }
      }
    }

    function openModal(kit, fallbackUrl) {
      if (!modal || !modalBody || !kit) {
        if (fallbackUrl) window.location.href = fallbackUrl;
        return;
      }
      modalOpener = document.activeElement;
      buildQuickView(kit);
      if (modalPanel) modalPanel.setAttribute('aria-label', kit.name || 'Product details');
      modal.hidden = false;
      document.documentElement.classList.add('sh-modal-open');
      if (modalCloseBtn) modalCloseBtn.focus();
    }

    function closeModal() {
      if (!modal || modal.hidden) return;
      modal.hidden = true;
      if (modalBody) modalBody.innerHTML = '';
      document.documentElement.classList.remove('sh-modal-open');
      if (modalOpener && typeof modalOpener.focus === 'function') modalOpener.focus();
      modalOpener = null;
    }

    if (modal) {
      $$('[data-sh-modal-close]', modal).forEach(function (el) {
        el.addEventListener('click', closeModal);
      });
      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' || e.key === 'Esc') closeModal();
      });
      $$('.sh-kit__media[data-sh-pdp-url]').forEach(function (media) {
        media.addEventListener('click', function (e) {
          if (e.target.closest('.sh-gal__dot')) return;
          var card = media.closest('.sh-kit');
          var kit = card ? kits[card.getAttribute('data-key')] : null;
          openModal(kit, media.getAttribute('data-sh-pdp-url'));
        });
      });
    }

    $$('[data-sh-kit-add]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var id = btn.getAttribute('data-variant-id');
        if (!id || btn.classList.contains('is-added')) return;
        btn.setAttribute('aria-disabled', 'true');
        cartAdd(id).then(function () {
          btn.textContent = strings.addedLabel || 'In your bag';
          btn.classList.add('is-added');
          btn.removeAttribute('aria-disabled');
        }).catch(function () {
          btn.removeAttribute('aria-disabled');
          showError();
        });
      });
    });

    /* ---------- back to top ---------- */

    /* The last section on the page carries a "Back to the top" button
       (28 July 2026, Marcha's ask). Wired here so the scroll respects
       prefers-reduced-motion like every other scroll on the page. */
    $$('[data-sh-top]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        window.scrollTo({ top: 0, behavior: scrollBehavior });
      });
    });

    /* ---------- deep links ---------- */

    function applyHash() {
      var h = (window.location.hash || '').replace('#', '');
      if (!h) return;

      if (h.indexOf('reveal-') === 0) {
        var handle = h.slice('reveal-'.length);
        var match = null;
        Object.keys(kits).forEach(function (k) {
          if ((kits[k].url || '').split('/').pop() === handle) match = kits[k];
        });
        if (match) {
          renderReveal({
            rule: { reason: match.character || '', also: [] },
            kit: match, variant: resolveVariant(match, null, null), promoted: false
          });
        }
        return;
      }

      var names = cards.map(function (c) { return c.getAttribute('data-sh-card'); });
      var at = names.indexOf(h);
      if (at > -1) showStep(at);
    }

    /* ---------- cart re-hydrate ---------- */

    var cartVariants = {};
    function syncAltCartState() {
      $$('[data-sh-alt-add]').forEach(function (btn) {
        if (cartVariants[String(btn.getAttribute('data-variant-id'))]) {
          btn.textContent = strings.addedLabel || 'In your bag';
          btn.classList.add('is-added');
        }
      });
    }

    /* ---------- boot ---------- */

    buildStepper();

    if (rActions) {
      var again = document.createElement('button');
      again.type = 'button';
      again.className = 'sh-link sh-link--quiet';
      again.textContent = strings.changeLabel || 'Change my answers';
      again.addEventListener('click', function () {
        showStep(0);
        if (cardsWrap) cardsWrap.scrollIntoView({ behavior: scrollBehavior, block: 'center' });
      });
      rActions.appendChild(again);
    }

    showStep(0);
    if (cardsWrap) cardsWrap.classList.add('is-collapsed');

    $$('[data-sh-gal]').forEach(addGalleryDots);
    buildGridOptions();
    buildDetailsToggles();
    renderTray();
    applyHash();

    cartGet().then(function (cart) {
      (cart.items || []).forEach(function (item) { cartVariants[String(item.variant_id)] = true; });
      $$('[data-sh-kit-add]').forEach(function (btn) {
        if (cartVariants[String(btn.getAttribute('data-variant-id'))]) {
          btn.textContent = strings.addedLabel || 'In your bag';
          btn.classList.add('is-added');
        }
      });
      syncAltCartState();
    }).catch(function () { /* cart unreachable */ });
  });
})();
